export default{
    headlist:[
        {
            name:"文件上传"
        },
        // {
        //     name:"结果展示"
        // },
        {
            name:"票据明细"
        },
        {
            name:"上传结果"
        }
    ]
}